module.exports = __webpack_public_path__ + "img/logo.d77843e6.png";